import { ChangeEvent, InputHTMLAttributes } from 'react'

import s from './AdminInput.module.scss'

interface AdminInputType extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  label?: string
  labelWeight?: number
  labelSize?: string
  onChange: (value: any) => void
}

export const AdminInput = ({ label, labelWeight, labelSize, onChange, ...props }: AdminInputType) => {
  const changeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    props.type === 'file' ? onChange!(e.target.files![0]) : onChange!(e.target.value)
  }

  return (
    <label style={{ fontSize: labelSize || '18px', fontWeight: labelWeight || 400 }}>
      {label}
      <input {...props} className={[s.input, props.type === 'file' && s.cursor].join(' ')} onChange={changeHandler} />
    </label>
  )
}
